import {
  AfterViewInit,
  booleanAttribute,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { BreadcrumbService } from './services/breadcrumb.service';
import { BreadcrumbStoreService } from './services/breadcrumb-store.service';
import { BreadcrumbDropdownTriggerStore } from './services/breadcrumb-dropdown-trigger.store';
import { BreadcrumbHomeItemComponent } from './components/breadcrumb-home-item/breadcrumb-home-item.component';
import { BreadcrumbItemComponent } from './components/breadcrumb-item.component/breadcrumb-item.component';
import { BreadcrumbDropdownItemComponent } from './components/breadcrumb-dropdown-item.component/breadcrumb-dropdown-item.component';
import { BreadcrumbHomeItemService } from './components/breadcrumb-home-item/breadcrumb-home-item.service';
import { ThemedIconComponent } from '../../atoms';
import { HlmBreadcrumbImports } from '@spartan-ng/helm/breadcrumb';

@Component({
  selector: 'ocp-breadcrumb',
  imports: [
    BreadcrumbHomeItemComponent,
    BreadcrumbItemComponent,
    BreadcrumbDropdownItemComponent,
    ThemedIconComponent,
    HlmBreadcrumbImports,
  ],
  templateUrl: './breadcrumb.component.html',
  styles: `
    :host {
      min-width: 0;
    }
  `,
  host: {
    class: 'ocp-breadcrumb',
    '[class.ocp-breadcrumb--minified]': 'minified()',
  },
  providers: [BreadcrumbService, BreadcrumbStoreService, BreadcrumbHomeItemService],
})
export class BreadcrumbComponent implements OnInit, AfterViewInit {
  /**
   * When true, shows only the first item (home) and the last item, separated by a separator.
   */
  minified = input(false, { transform: booleanAttribute });

  protected readonly breadcrumbService = inject(BreadcrumbService);
  protected readonly breadcrumbStoreService = inject(BreadcrumbStoreService);
  protected readonly breadcrumbHomeItemService = inject(BreadcrumbHomeItemService);
  private readonly dropdownTriggerStore = inject(BreadcrumbDropdownTriggerStore);
  private readonly destroyRef = inject(DestroyRef);
  private readonly hostElement = inject<ElementRef<HTMLElement>>(ElementRef);
  protected readonly router = inject(Router);

  private readonly shouldOpenHomeDropdown$ = toObservable(
    this.dropdownTriggerStore.shouldOpenHomeDropdown
  );

  ngOnInit() {
    this.breadcrumbService.initRouteListener();
    this.breadcrumbStoreService.setMinified(this.minified());
  }

  ngAfterViewInit() {
    this.shouldOpenHomeDropdown$
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const triggerButton = this.hostElement.nativeElement.querySelector(
          '.breadcrumb__menu-trigger'
        ) as HTMLElement | null;

        if (triggerButton) {
          triggerButton.click();
        }

        this.dropdownTriggerStore.resetTrigger();
      });
  }

  protected normalizeRouterLink(
    routerLink: string | readonly (string | number)[] | undefined
  ): string {
    if (typeof routerLink === 'string') {
      return routerLink;
    }

    if (Array.isArray(routerLink)) {
      return routerLink.map(String).join('/');
    }

    return '';
  }
}
